function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import MuiDivider from '@material-ui/core/Divider';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { defaultGreyDisabled } from "../../utils/colors";
var noBackground = {
  backgroundColor: 'unset'
};
var useStyles = makeStyles({
  dashed: _objectSpread({
    borderTop: "dashed 1px ".concat(defaultGreyDisabled)
  }, noBackground),
  solid: _objectSpread({
    borderTop: "solid 1px ".concat(defaultGreyDisabled)
  }, noBackground)
});
export var Divider = function Divider(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'dashed' : _ref$variant;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(MuiDivider, {
    classes: {
      root: classes[variant] // class name, e.g. `classes-nesting-root-x`

    }
  });
};
Divider.defaultProps = {
  variant: 'dashed'
};
Divider.propTypes = {
  variant: PropTypes.oneOf(['dashed', 'solid'])
};
export default Divider;